import type { SxProps, Theme } from '@mui/material';

/** Full-bleed chat frame inside DashboardLayout `main`. */
export const chatPageSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  width: '100%',
  minWidth: 0,
  // App bar + fixed footer clearance
  minHeight: { xs: 'calc(100dvh - 56px - 52px)', sm: 'calc(100dvh - 64px - 52px)' },
  bgcolor: 'background.default',
};

export const chatPanelScrollSx: SxProps<Theme> = {
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  px: { xs: 1.5, sm: 2.5 },
  py: 2,
  '&::-webkit-scrollbar': { width: 8 },
  '&::-webkit-scrollbar-thumb': {
    bgcolor: 'rgba(255,255,255,0.15)',
    borderRadius: 4,
  },
};
